module.exports = __webpack_public_path__ + "static/media/aqua_02.68acb0f1.png";